import { WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import {
  destroy,
  getFormAsyncErrors,
  isAsyncValidating,
  isDirty,
  isSubmitting,
  submit,
} from 'redux-form'
import { toggleUpdateReservationModal } from '../../../actions/bookingCalendar/reservationModal/toggleReservationModal'
import { ToggleCreateModal } from '../../../actions/bookingCalendar/reservationModal/toggleConfigurationModal'
import { IStore } from '../../../reducers'
import {
  getModalDeleteReservationIsOpen,
  getModalReservationIsLoading,
  getModalReservationIsSaving,
  getModalUpdateReservationIsOpen,
} from '../../../reducers/bookingCalendar/selectors/getModalOpen'
import { FormNames } from '../../Form/CreateReservation'
import { toggleCloseModal } from '../../../actions/bookingCalendar/reservationModal/toggleCloseModal'
import requestDeleteEvent from '../../../actions/bookingCalendar/event/requestDeleteEvent'
import fireToastError from '../../../actions/toasts/fireToastError'
import selectReservationTab from '../../../actions/bookingCalendar/reservationModal/selectReservationTab'
import { getUpdateReservationFormEvent } from '../../../reducers/bookingCalendar/selectors/events'
import toggleDeleteReservationModal from '../../../actions/bookingCalendar/reservationModal/toggleDeleteReservationModal'
import openModal from '../../../actions/Modals/openModal'
import closeModal from '../../../actions/Modals/closeModal'
import {
  IReservationModalDispatch,
  IReservationModalProps,
} from './ReservationModal'
import { getModalIsHidden } from '../../../reducers/modals/selectors/getModals'
import { isInScope } from '../../../hooks/useIsScope'
import { PermissionScope } from '../../Employees'

const mapStateToProps = () => {
  return (state: IStore): IReservationModalProps => {
    const rawEvent = getUpdateReservationFormEvent(state)
    const scope = isInScope(state)
    return {
      booking: rawEvent ? rawEvent.bookingId : '',
      airbnb: rawEvent ? rawEvent.airbnbId : '',
      rawEvent: rawEvent,
      deleteModal: getModalDeleteReservationIsOpen(state),
      errors: getFormAsyncErrors('update_reservation')(state),
      isDirty: isDirty(FormNames.Update)(state),
      isLoading: getModalReservationIsLoading(state),
      isSaving: getModalReservationIsSaving(state),
      isSubmitting: isSubmitting(FormNames.Update)(state),
      hideModal: getModalIsHidden(state),
      isValidating: isAsyncValidating(FormNames.Update)(state),
      open: getModalUpdateReservationIsOpen(state),
      type: 'update',
      allowReservationEdit: scope([
        PermissionScope.SCOPE_CAN_EDIT_RESERVATIONS,
      ]),
    }
  }
}

const bindDispatchToProps = (
  dispatch: Dispatch,
): IReservationModalDispatch => ({
  deleteEvent: () => dispatch(requestDeleteEvent()),
  fireError: (message, id) => {
    dispatch(fireToastError(message, null, 'Event', id))
    dispatch(selectReservationTab(0))
  },
  modalClose(id) {
    dispatch(closeModal(id))
  },
  modalOpen(id, element) {
    dispatch(openModal(id, element))
  },
  onClose() {
    dispatch(toggleUpdateReservationModal(null, false))
    dispatch(destroy(FormNames.Update))
  },
  submitForm() {
    dispatch(submit(FormNames.Update))
  },
  toggleCloseModal() {
    dispatch(toggleCloseModal(true))
  },
  toggleConfigurationModal() {
    dispatch(ToggleCreateModal())
  },
  toggleDeleteModal: (toggle?: boolean) =>
    dispatch(toggleDeleteReservationModal(toggle)),
})

export default connect<
  IReservationModalProps,
  IReservationModalDispatch,
  WithTranslation
>(
  mapStateToProps(),
  bindDispatchToProps,
)
